<template>
  <el-row class="bv-login" style="background-color: #ccc">
    <el-col :span="24" class="bv-login__form-login">
      <div style="width: 450px; border: 1px solid #eee; padding: 40px 30px; background-color: #fff; border-radius: 4px">
          <h1>Nga Linh</h1>
        <div>
          <h2>Đăng nhập hệ thống</h2>
          <span class="desciption">Điền thông tin: </span>
          <el-form ref="form" @submit.native.prevent :model="userInfo">
            <div class="form-group">
              <label>E-mail</label>
              <input
                type="text"
                name="email"
                v-model="userInfo.username"
                placeholder="E-mail"
                v-validate="'required|email'"
                data-vv-as="Email">
              <span class="error" v-show="errors.has('email')">{{ errors.first('email') }}</span>
            </div>
            <div class="form-group">
              <label>Password</label>
              <input
                type="password"
                name="password"
                v-model="userInfo.password"
                placeholder="Password"
                v-validate="'required|min:6'"
                data-vv-as="Mật khẩu">
              <span class="error" v-show="errors.has('password')">{{ errors.first('password') }}</span>
            </div>
            <el-button
              :disable="!canSubmit"
              :loading="!canSubmit"
              type="primary"
              native-type="submit"
              @click="validateBeforeSubmit">Login
            </el-button>
          </el-form>
        </div>
      </div>
    </el-col>
  </el-row>
</template>

<script>
import axios from 'axios'
import ls from 'local-storage'
import { head } from 'lodash'
import { mapActions, mapGetters } from 'vuex'
export default {
  inject: ['$validator'],
  name: 'Login',
  data () {
    return {
      canSubmit: true,
      userInfo: {
        username: '',
        password: ''
      }
    }
  },
  computed: {
    ...mapGetters('account', ['logged', 'accountInfo'])
  },
  mounted () {
    if (this.logged) {
      this.$router.push({name: 'home-index'})
    }
  },
  methods: {
    ...mapActions('account', ['getAccountInfo']),
    validateBeforeSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.canSubmit = false
          axios.post('login', this.userInfo).then((response) => {
            this.canSubmit = true
            switch (response.code) {
              case 200:
                ls('authen', response)
                this.$notify({
                  title: 'Thành công',
                  message: 'Đăng nhập thành công',
                  type: 'success'
                })
                this.getAccountInfo()
                if (this.logged) {
                  this.$router.push({name: 'home-index'})
                }
                break
              case 401:
                this.$notify({
                  title: 'Lỗi đăng nhập',
                  message: 'Bạn không được phép truy cập vào hệ thống',
                  type: 'warning'
                })
                this.$router.push({name: 'account-login'})
                break
              case 403:
                this.$router.push({name: 'account-login'})
                break
              case 422:
                let er = response.data.errors
                let message = head(er[Object.keys(er)[0]])
                this.$notify({
                  title: 'Đăng nhập thất bại',
                  message: message,
                  type: 'warning'
                })
                break
              default:
                this.$notify.error({
                  title: 'Error',
                  message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
                })
                this.$router.push({name: 'account-login'})
                break
            }
          })
        } else {
          this.$notify({
            title: 'Có lỗi xảy ra',
            message: 'Vui lòng kiểm tra lại thông tin',
            type: 'warning'
          })
        }
      })
    }
  },
  watch: {
    logged () {
      if (this.logged) {
        this.$router.push({name: 'home-index'})
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.bv-login__image-preview {
  height: 100vh;
  background-color: #f9f9f9;
  background-image: url('../../static/images/login/login-min.jpg');
  background-size: cover;
  position: relative;
}

/*bv-login__description*/
.bv-login__description {
  position: absolute;
  bottom: 35px;
  left: 35px;
  display: flex;
  flex-direction: column;
}
.bv-login__description span {
  font-size: 30px;
  font-weight: bold;
  color: #fff;
}

/*.bv-login__form-login*/
.bv-login__form-login {
  height: 100vh;
  align-items: center;
  display: flex;
  background-color: #eee;
  background: #6D6027;  /* fallback for old browsers */
  background: -webkit-linear-gradient(to right, #D3CBB8, #6D6027);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(to right, #D3CBB8, #6D6027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  /*border-top: 5px solid #2EA8ED;*/
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 5px 25px;
}
.bv-login__form-login .desciption {
  /*text-transform: uppercase;*/
  font-size: 13px;
  font-weight: bold;
  color: #717171;
}
.bv-login__form-login .el-form {
  padding-top: 10px;
}
.bv-login__form-login .form-group {
  display: flex;
  flex-direction: column;
  padding: 8px 10px;
  border: 2px solid #EFF0F1;
  border-radius: 2px;
  margin-bottom: 15px;
}
.bv-login__form-login .error {
  color: #e74c3c;
}
.bv-login__form-login label {
  margin-bottom: 1px;
  font-size: 11px;
}
.bv-login__form-login input {
  padding: 5px 0px 2px 0px;
  border: none;
  font-size: 14px;
}
.bv-login__form-login button {
  background-color: #22A7F0;
  color: #eee;
  border-radius: 2px;
  text-transform: uppercase;
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/components/account/Login.vue